const BASE_URL = "https://ikoffices.com";

const positivePrice = (value) => {
  const price = Number(value);
  return Number.isFinite(price) && price > 0 ? price : 0;
};

// Only publish prices that belong to an actual purchase/rental offer. A monthly
// rental and a one-time purchase are not the low/high range of one offer.
export function productOffers(product, canonical) {
  const saleType = product.saleType || "sale";
  const price = positivePrice(product.price);
  const rentalPrice = positivePrice(product.rentalPrice);
  const common = {
    "@type": "Offer",
    url: canonical,
    priceCurrency: "KRW",
    availability: product.stockStatus === "soldout" ? "https://schema.org/OutOfStock" : "https://schema.org/InStock",
    seller: { "@type": "Organization", name: "일광오피스", url: BASE_URL },
  };
  const offers = [];
  if ((saleType === "rental" || saleType === "both") && rentalPrice) {
    offers.push({
      ...common,
      name: "월 렌탈",
      price: rentalPrice,
      priceSpecification: {
        "@type": "UnitPriceSpecification", price: rentalPrice, priceCurrency: "KRW", unitText: "월",
        referenceQuantity: { "@type": "QuantitativeValue", value: 1, unitCode: "MON" },
      },
    });
  }
  if ((saleType === "sale" || saleType === "both") && price) {
    offers.push({ ...common, name: "구매", price });
  }
  return offers;
}
